import { useApi } from './apiService';

export const useLicenseInfo = () => {
  const api = useApi();

  const getLicenseInfo = async (tenantId: string) => {
    try {
      const response = await api.get(`/tenantservice/Tenant/${tenantId}/license-info`);
      return response.data;
    } catch (error) {
      console.error('Error fetching license info:', error);
      throw error;
    }
  };

  return { getLicenseInfo };
};
